export default {
  GET_TEST_DRIVES: (state) => state.test_drives,
  GET_TEST_DRIVE_UNITS: (state) => state.test_drive_units,
  GET_TEST_DRIVE: (state) => state.test_drive,
  GET_STATUSES: (state) => state.statuses,
  GET_ACTIONS: (state) => state.actions,
  GET_MODELS: (state) => state.models,
  GET_DEALERS: (state) => state.dealers,
};
